const brlFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const numberFormatter = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatCurrency(value) {
  return brlFormatter.format(Number(value || 0)).replace(/\u00A0/g, ' ');
}

export function parseCurrencyInput(value) {
  const raw = String(value ?? '').trim();
  if (!raw) return '';

  const cleaned = raw.replace(/[^\d,.-]/g, '');
  const normalized = cleaned.includes(',')
    ? cleaned.replace(/\./g, '').replace(',', '.')
    : cleaned;

  const parsed = Number(normalized);
  if (!Number.isFinite(parsed)) return '';

  return parsed.toFixed(2);
}

export function formatCurrencyInput(value) {
  const parsed = parseCurrencyInput(value);
  if (!parsed) return '';
  return numberFormatter.format(Number(parsed));
}
